import { CalendarMonth } from '@mui/icons-material';
import {
  Box,
  Button,
  Divider,
  ListItemText,
  Menu,
  MenuItem,
  Stack,
  Typography,
  useTheme
} from '@mui/material';
import { CustomIcons } from 'modules/components/layer00';
import { ReactNode } from 'react';



export type FullWIdthSummaryCardLayoutProps = {
  dataSource: string;
  dataLink: string;
  children: ReactNode | ReactNode[];
};


/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = (props: FullWIdthSummaryCardLayoutProps) => {
  const theme = useTheme();

  return (
    <Box
      bgcolor={theme.palette.primary.darker200}
      borderRadius='1rem'
      padding='1rem'
    >
      <Box
        display='flex'
        justifyContent='space-between'
        alignItems='center'
        flexDirection='row'
      >
        <Stack
          flex='1 1 0'
          component='span'
          alignItems='center'
          direction='row'
          columnGap='.75rem'
        >
          <Typography
            variant='dataSummaryCardTitle'
            color={theme.palette.primary.main}
          >
            {props.dataSource}
          </Typography>
          <Divider
            sx={{
              background: '#02C37E33'
            }}
            orientation='vertical'
            variant='middle'
          />

          <Button
            variant='text'
            color='primary'
            endIcon={(
              <CustomIcons.SmallCustomIcon.FC
                icon='STATLINK'
                stroke={theme.palette.primary.main}
              />
            )}
          >
            Source
          </Button>

        </Stack>

        <Button
          sx={{
            backgroundColor: theme.palette.primary.darker180,
            color: 'white',
            textAlign: 'left',
            minWidth: '5rem',
            borderRadius: '.375rem',
            boxShadow: 'none'
          }}
          variant='text'
          color='primary'
          disableElevation
          disableRipple


          startIcon={<CalendarMonth />}
        >
          Latest
        </Button>
        <Menu
          variant='selectedMenu'
          open={false}
          defaultValue='1M'
        >
          <MenuItem value='1M'>
            <ListItemText>1M</ListItemText>
          </MenuItem>
        </Menu>
      </Box>
      <Box
        paddingTop='1rem'
        overflow='auto'
        display='flex'
        columnGap='1rem'
        flexDirection='row'
      >
        {props.children}
      </Box>
    </Box>
  );
};
